import React, { useState, useEffect } from "react";
import "./reports.css";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";
import { ButtonGroup, ToggleButton } from "react-bootstrap";
import moment from "moment";

const defaultRangeOptions = [
  { name: "Weekly", value: 0, days: 7 },
  { name: "Monthly", value: 1, days: 30 }
];

function FilterItems({
  filterFunction,
  start_date,
  triger,
  channel,
  rangeOptions = defaultRangeOptions,
  defaultRangeValue
}) {
  const resolvedRangeOptions = Array.isArray(rangeOptions) && rangeOptions.length > 0
    ? rangeOptions
    : defaultRangeOptions;

  const weeklyOption = resolvedRangeOptions.find(
    (item) => String(item?.name || "").toLowerCase() === "weekly"
  );

  const resolvedDefaultValue =
    defaultRangeValue !== undefined && defaultRangeValue !== null
      ? defaultRangeValue
      : (weeklyOption ? weeklyOption.value : resolvedRangeOptions[0].value);

  const [visibe, setVisible] = useState(resolvedDefaultValue);
  const [offsets, setOffsets] = useState({ [resolvedDefaultValue]: 0 });

  const [dates, setDates] = useState({ startDate: "", endDate: "", diff: 0 });

  useEffect(() => {
    setVisible(resolvedDefaultValue);
    setOffsets({ [resolvedDefaultValue]: 0 });
  }, [triger, resolvedDefaultValue]);

  const _MS_PER_DAY = 1000 * 60 * 60 * 24;

  // a and b are javascript Date objects
  function dateDiffInDays(a, b) {

    a = new Date(a)
    // Discard the time and time-zone information.
    const utc1 = Date.UTC(a.getFullYear(), a.getMonth(), a.getDate());
    const utc2 = Date.UTC(b.getFullYear(), b.getMonth(), b.getDate());

    return Math.floor((utc2 - utc1) / _MS_PER_DAY);
  }

  // test it
  const changeDate = async () => {
    const selectedOption = resolvedRangeOptions.find(
      (item) => String(item.value) === String(visibe)
    ) || resolvedRangeOptions[0];

    const daysToShift = selectedOption?.days || 7;
    let endDate = moment().format("YYYY-MM-DD");
    let startDate = moment().subtract(daysToShift - 1, "days").format("YYYY-MM-DD");

    const currentOffset = offsets?.[visibe] || 0;
    const totalShiftDays = Math.abs(currentOffset * daysToShift);

    if (currentOffset < 0) {
      startDate = moment(startDate).subtract(totalShiftDays, "days").format("YYYY-MM-DD");
      endDate = moment(endDate).subtract(totalShiftDays, "days").format("YYYY-MM-DD");
    } else if (currentOffset > 0) {
      startDate = moment(startDate).add(totalShiftDays, "days").format("YYYY-MM-DD");
      endDate = moment(endDate).add(totalShiftDays, "days").format("YYYY-MM-DD");
    }

    setDates({
      startDate,
      endDate,
      diff: dateDiffInDays(endDate, new Date())
    });
    filterFunction(startDate, endDate, selectedOption?.name || "Weekly");
  };


  useEffect(() => {
    changeDate();
  }, [visibe, offsets]);

  const formatDisplayDate = (date) => {
    if (!date) {
      return "";
    }
    return moment(date).format("MMM DD, YYYY");
  };

  const displayStartDate = formatDisplayDate(dates.startDate);
  const displayEndDate = formatDisplayDate(dates.endDate);

  return (
    <div className="graphFilterContainer">
      {//console.log(dates)
      }
      <div
        className={`dates ${dates.diff > 0 ? 'alignDate' : ''}`}
      >{displayStartDate && displayEndDate ? `${displayStartDate} - ${displayEndDate}` : ""}</div>
      <div
        className="filterItems_graph"
      >
        <ArrowBackIosIcon
          className="iconsFilter"
          onClick={() => {
            setOffsets((prev) => ({
              ...prev,
              [visibe]: (prev?.[visibe] || 0) - 1
            }));
          }}
        />
        <ButtonGroup className="analytics-toggle-group mx-2">
          {resolvedRangeOptions.map((radio, idx) => (
            <ToggleButton
              key={radio.value}
              id={`analytics-range-${idx}`}
              type="radio"
              variant="light"
              name="analytics-range"
              value={radio.value}
              checked={String(visibe) === String(radio.value)}
              className={`analytics-toggle-btn ${(radio.name || "").toLowerCase().replace(/\s+/g, "-")} ${String(visibe) === String(radio.value) ? "is-active" : ""}`}
              onChange={() => setVisible(radio.value)}
            >
              {radio.name}
            </ToggleButton>
          ))}
        </ButtonGroup>
        {dates.diff > 0 && <ArrowForwardIosIcon
          className="iconsFilter"
          onClick={() => {
            setOffsets((prev) => ({
              ...prev,
              [visibe]: (prev?.[visibe] || 0) + 1
            }));
          }}
        />}
      </div>
    </div>
  );
}

export default FilterItems;
